export const EVENT = {
  title: "A VIEW FROM THE TOP",
  live: "LIVE with Susan Grau",
  subtitle: "An Evening of Mediumship",
  dateLabel: "Thursday, January 14, 2027",
  doors: "6:00 PM",
  showStart: "7:00 PM",
  showEnd: "9:30 PM",
  venue: "The Saban Theatre",
  address: "8440 Wilshire Blvd, Beverly Hills, CA 90211",
  venuePhone: "1-844-753-8303",
  accessibilityPhone: "310-228-7504",
  showTimeISO: "2027-01-14T19:00:00-08:00",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Saban+Theatre+8440+Wilshire+Blvd+Beverly+Hills+CA+90211",
  capacity: 1838,
};

export const BOOK = {
  title: "Infinite Life, Infinite Lessons",
  fullTitle:
    "Infinite Life, Infinite Lessons: Wisdom from the Spirit World on Living, Dying, and the In-Between",
  publisher: "Hay House",
  amazonUrl: "https://a.co/d/06GyXM1f",
  signedAddonPrice: 35,
  nextBook: "When Shadows Speak — with a foreword by Valerie Bertinelli, arriving 2027",
};

export const SHOW = {
  name: "A View from the Top with Susan Grau",
  site: "https://www.susangrau.com",
  site2: "https://meetsusangrau.com",
  studioTicketsUrl: "https://myinfinite.app/show",
  studioNote: "Want studio-audience seats at CBS Television City? Visit myinfinite.app/show",
  network: "CBS Television City",
};

export const SOCIALS = [
  { id: "instagram", label: "Instagram", handle: "@susangrauofficial", url: "https://www.instagram.com/susangrauofficial" },
  { id: "youtube", label: "YouTube", handle: "@susangrauofficial", url: "https://www.youtube.com/@susangrauofficial" },
  { id: "facebook", label: "Facebook", handle: "@susangrauofficial", url: "https://www.facebook.com/susangrauofficial" },
  { id: "tiktok", label: "TikTok", handle: "@susangrauofficial", url: "https://www.tiktok.com/@susangrauofficial" },
];

export const APP = {
  name: "MyInfinite",
  url: "https://myinfinite.app",
  tagline: "Susan's own app — daily spirit wisdom, meditations, and messages in your pocket.",
};

export const NDE = {
  eyebrow: "Where Her Gift Began",
  titleLines: ["At four and a half years old,", "Susan died — and came back", "able to hear the other side."],
  quote: "Pain may become part of your story — it never has to become your identity.",
  beats: [
    {
      h: "Locked in the freezer",
      p: "Playing with the neighborhood boys in her parents' garage, four-and-a-half-year-old Susan was locked inside an unplugged freezer.",
    },
    {
      h: "Held by angels",
      p: "She crossed. She describes a magnificent presence of the Divine, held by angels, in a vast and beautiful place — beside what she calls the Well of Knowledge, where she perceived the prayers and desires of everyone living.",
    },
    {
      h: "The whisper that saved her",
      p: "Her mother heard a voice say: 'Your baby is in the freezer.' Susan came back — and was forever changed.",
    },
    {
      h: "The gift that stayed",
      p: "From that day she could feel, see, hear, and speak with spirit. She hid it for years — then spent a lifetime turning it into a way to heal the grieving. Today she holds a Doctorate of Divinity, studied alongside Dr. Raymond Moody.",
    },
  ],
  clairs: [
    { h: "Clear Knowing", p: "Her strongest sense — spirit information simply arrives: who they are, their relationship to you, even how they passed." },
    { h: "Clear Seeing", p: "Susan sees spirit — scenes, symbols, and the faces of your people as they step forward." },
    { h: "Clear Hearing", p: "She hears their voices: the exact phrases, the nicknames, the evidence that only they would say." },
    { h: "Clear Feeling", p: "She feels what they felt — the love, the apology, the moment they want you to know about." },
  ],
  clairsNote:
    "She describes a 'mental dial' that turns her sensitivity up for you and down for herself — she never forces a connection, she softens and listens. Every reading is evidential: names, memories, and personalities first — proof before comfort.",
};

export const PRESS = [
  "The Drew Barrymore Show",
  "CBS",
  "Elle",
  "The Hollywood Reporter",
  "Goop",
  "Lifetime",
  "Gaia",
  "Yahoo!",
  "Publishers Weekly",
  "Beyond the Grave",
];

export const STATS = [
  { value: "30+", label: "Years of practice" },
  { value: "60,000", label: "Private clients guided" },
  { value: "580M+", label: "Media views worldwide" },
  { value: "10,000+", label: "Copies of her book sold" },
];

export const CREDENTIALS = [
  "International Bestselling Author — Hay House",
  "Master Evidential Medium",
  "Doctor of Divinity — studied with Dr. Raymond Moody",
  "Certified Grief Specialist & Addiction Counselor",
  "Licensed Hypnotherapist",
  "Reiki Master",
  "Professional Teacher of the Metaphysical Arts",
  "Hay House 'Heal Your Life' Reader, Speaker & Teacher",
  "Host of A View from the Top with Susan Grau",
];

export const TIERS = [
  {
    id: "vipexp",
    name: "VIP Experience",
    badge: "First 2 Rows · After-Show Group Reading",
    priceLabel: "$1,000",
    priceNote: "Only 64 seats in the house",
    perks: [
      "First 2 rows — the closest seats to Susan",
      "Private after-show group reading for first-two-row guests",
      "Signed hardcover of Infinite Life, Infinite Lessons",
      "Post-show photo op + priority VIP entrance",
    ],
  },
  {
    id: "selectp",
    name: "Select+ · Meet & Greet",
    badge: "Meet & Greet + Photo Op",
    priceLabel: "$149",
    priceNote: "Front section — rows C to E",
    perks: [
      "Front-section seats, right at stage level",
      "Meet & greet with Susan after the show",
      "Post-show photo op",
      "Priority entrance",
    ],
  },
  {
    id: "select",
    name: "Select",
    badge: "Closer to the Front",
    priceLabel: "$129",
    priceNote: "Rows F to J",
    perks: [
      "Seats closer to the front with a direct stage view",
      "The clearest acoustic field in the house",
      "Close enough for the energy of live readings",
    ],
  },
  {
    id: "general",
    name: "General",
    badge: "Best Value",
    priceLabel: "$90",
    priceNote: "Main floor — rows K to Z",
    perks: [
      "Main-floor seats with a full stage view",
      "The easiest way to be in the room",
      "Close enough for the energy of live readings",
    ],
  },
  {
    id: "mezzanine",
    name: "Mezzanine",
    badge: "Sold Out",
    soldOut: true,
    priceLabel: "Sold Out",
    priceNote: "Fully reserved — no seats remain",
    perks: [],
  },
  {
    id: "balcony",
    name: "Balcony",
    badge: "Sold Out",
    soldOut: true,
    priceLabel: "Sold Out",
    priceNote: "Fully reserved — no seats remain",
    perks: [],
  },
];

export const PROGRAM = [
  { time: "6:00 PM", title: "Doors & New Year Welcome Lounge", text: "Candlelight, champagne glow, warm drinks, and music beneath the Saban's gilded dome — plus early entry for VIP Experience and Select+ ticket holders." },
  { time: "7:00 PM", title: "A View from the Top — Live", text: "Susan opens the evening and rolls straight into the show: the LIVE event version, taped in front of you for its New Year 2027 special premiere, then the mediumship begins." },
  { time: "7:45 PM", title: "Live Evidential Readings", text: "Messages delivered to audience members as loved ones come through — the heart of the night." },
  { time: "8:15 PM", title: "Intermission", text: "Festive treats, the remembrance tree, and signed copies of Susan's book." },
  { time: "8:35 PM", title: "Candlelight Remembrance", text: "The house glows as we honor the people we carry with us — the emotional peak of the night." },
  { time: "9:30 PM", title: "The Evening Closes", text: "A final blessing for the new year ahead. VIP Experience and Select+ guests stay for their meet & greet and photo op with Susan." },
];

export const TESTIMONIALS = [
  {
    quote: "I had the most life-changing session with Susan Grau. I highly recommend her if you're feeling like there's a stumbling block you can't get through.",
    author: "Valerie Bertinelli",
    role: "Emmy-winning actress & author",
  },
  {
    quote: "Infinite Life, Infinite Lessons is a captivating narrative and a profound journey of personal growth through adversity.",
    author: "Anita Moorjani",
    role: "New York Times bestselling author",
  },
  {
    quote: "Throughout Infinite Life, Infinite Lessons, Susan embarks on an extraordinary journey of self-discovery and spiritual awakening.",
    author: "Kim Russo, PhD",
    role: "'The Happy Medium'",
  },
  {
    quote: "Susan Grau is the real deal. Her words are a guide to tapping into our own intuition and staying in communion with loved ones on the other side.",
    author: "Dr. Laura Berman",
    role: "Relationship expert & author",
  },
];

export const VENUE_TABS = [
  {
    id: "parking",
    label: "Parking & Arrival",
    title: "Getting to 8440 Wilshire Blvd",
    items: [
      { h: "Theatre Valet", p: "Valet service is available at the theatre's main entrance on Wilshire Blvd. A fee applies, payable to the attendant — arrive early on event nights as the line builds close to curtain." },
      { h: "Underground Lots Nearby", p: "Two independent structures sit steps from the doors: the Nibblers Building lot (enter from Gale Dr, just north of Wilshire) and the Flynt Communications Building lot (enter from Hamilton Dr, just south of Wilshire)." },
      { h: "Metered Street Parking", p: "Metered street parking is free after 6:00 PM on Tower Dr, Gale Dr, Hamilton Dr (south of Wilshire), Gregory Way, and Le Doux Road — our doors open at 6:00 PM sharp, so these fill early. On Wilshire Blvd itself, meters only allow parking from 7:00–11:00 PM." },
      { h: "Please Avoid Side Streets", p: "Residential streets around the theatre are permit-only and aggressively patrolled. Rideshare drop-off at the main entrance is the easiest late-night option." },
    ],
  },
  {
    id: "timeline",
    label: "Doors & Timeline",
    title: "How the Evening Flows",
    items: [
      { h: "6:00 PM — Doors Open", p: "New Year Welcome Lounge opens. Give yourself time for security screening and to find your seats before candlelight." },
      { h: "7:00 PM — Show Begins", p: "The Saban locks doors at showtime and late arrivals may be denied entry until an appropriate break, so please don't be late." },
      { h: "9:30 PM — Evening Ends", p: "VIP Experience and Select+ photo ops are taken immediately after the closing blessing." },
      { h: "Concessions", p: "Festive drinks and treats are available inside. Outside food and beverage are not permitted." },
    ],
  },
  {
    id: "accessibility",
    label: "Accessibility",
    title: "Every Guest Welcomed",
    items: [
      { h: "Step-Free Entry", p: "The theatre's main entrance is fully accessible, with accessible restrooms throughout the main floor." },
      { h: "Wheelchair & Companion Seating", p: "Designated wheelchair positions with adjacent companion seats are held on the main floor. Please arrange these in advance by calling the box office at 310-228-7504 — then choose our team's 'I need accessible seating' note at checkout and we will confirm your placement." },
      { h: "Important — Historic Building", p: "The Saban is a 1930 landmark with no elevators, and the Mezzanine and Balcony levels are sold out for this evening — all remaining seating is on the step-free main floor." },
      { h: "Questions", p: "Call the theatre at 1-844-753-8303 and our team will make the evening comfortable for you." },
    ],
  },
  {
    id: "dining",
    label: "Make a Night of It",
    title: "A Beverly Hills New Year Evening",
    items: [
      { h: "Dinner First", p: "The Wilshire corridor is lined with restaurants minutes from the theatre — from classic delis to upscale dining. Reserve for 5:00–5:30 PM to make the 6:00 PM doors comfortably." },
      { h: "The Neighbourhood", p: "Third Street and Beverly Drive are a short drive for after-drinks and dessert. Wilshire fills with event traffic close to curtain, so build in a buffer." },
      { h: "Dress Code", p: "There is no formal dress code — guests tend toward festive elegant. The candlelight remembrance will be photographed for Susan's community; VIP Experience and Select+ ticket holders will be individually photographed at the photo op." },
    ],
  },
];

export const FAQS = [
  { q: "How does the new pricing work?", a: "Four experiences, one map: General is $90 (main floor, rows K–Z), Select is $129 (rows F–J, closer to the front), Select+ is $149 (rows C–E and includes the meet & greet + photo op), and the VIP Experience is $1,000 — first 2 rows only, with a private after-show group reading just for those guests. The Mezzanine and Balcony levels are sold out." },
  { q: "How do I choose my exact seats?", a: "Three simple steps: choose your experience zone, pick your exact seats on the interactive map of the full 1,838-seat house, then add extras or gift at checkout. In a hurry? Tap Fast Pick in the corner and we'll automatically hold the best seats in your zone. What you select is what's held for you." },
  { q: "What's included in the $1,000 VIP Experience?", a: "Guaranteed seating in the first 2 rows — the closest seats to Susan — plus a personally signed hardcover of Infinite Life, Infinite Lessons, the post-show photo op, priority early entry through the VIP door, and an intimate group reading held after the show just for the first two rows. Only 64 of these seats exist in the whole house." },
  { q: "What does Select+ ($149) include?", a: "Select+ seats you in the front section (rows C–E) and includes the meet & greet with Susan after the show plus a post-show photo op — the best value for getting face to face." },
  { q: "Can I gift this evening to someone who is grieving?", a: "Yes — and it is the reason this show exists. Choose your seats, then switch on 'This is a gift' at checkout and add your friend's name, email, and a personal note. We'll send them a beautiful digital gift pass with your message, and their seats will be waiting for them under their name." },
  { q: "What actually happens at an evening of mediumship?", a: "Susan is a Master Evidential Medium: she delivers messages from loved ones who have passed, with specific evidence — names, memories, personalities — so you know it's really them. This particular evening is also a live taping of her show, A View from the Top. Readings are given to audience members as spirit comes through." },
  { q: "Will everyone receive a reading?", a: "Susan works with everyone the room collectively brings through across the 2.5-hour show, and messages reach far beyond the person they're delivered to. A seat does not guarantee a personal reading — mediumship is always spirit-led, never forced, and never promised — but nobody leaves this evening untouched. VIP guests are also invited to stay for a private after-show group reading held just for the first two rows." },
  { q: "Where do I park at the Saban Theatre?", a: "Theatre valet is at the main entrance on Wilshire (fee applies). Nearby underground lots: Nibblers Building (enter from Gale Dr, north of Wilshire) and Flynt Communications Building (enter from Hamilton Dr, south of Wilshire). Metered street parking is free after 6 PM on Tower, Gale, Hamilton (south of Wilshire), Gregory Way, and Le Doux. Avoid residential streets — permits are enforced." },
  { q: "Is the venue accessible?", a: "Yes — the main entrance is step-free with accessible restrooms, and wheelchair positions with companion seating are held on the main floor. One thing to know: the historic 1930 building has no elevators, so Mezzanine and Balcony are stairs-only. For accessible seating, call 310-228-7504 in advance." },
  { q: "What is the bag policy?", a: "Small purses and bags are permitted and will pass through security screening; clear bags are appreciated. No outside food or drink. The theatre asks that phones stay pocketed during the event — photography and recording of the readings are strictly prohibited to protect the privacy of the families receiving messages." },
  { q: "What if I arrive late?", a: "Doors lock at showtime. Late arrivals may be held in the lobby until a suitable break in the readings — another reason the 6:00 PM doors and lounge are worth arriving for." },
  { q: "Can I buy Susan's book at the show?", a: "Yes — signed copies of Infinite Life, Infinite Lessons (Hay House) will be available at intermission and after the show. You can also add a signed copy to your ticket order at checkout for pickup at the event, or order from Amazon right now via the link on this page." },
  { q: "What is the refund policy?", a: "All ticket sales are final. If your plans change, seats may be transferred to another guest for this evening by emailing the box office — a show like this makes a beautiful gift, after all." },
  { q: "Is there an age minimum?", a: "This is a seated, candlelit evening intended for adults and mature young people; we recommend ages 12 and up. Every guest needs their own seat and ticket." },
];

export const PHOTOS = {
  hero: "/images/drive-7058-cropped.jpg",
  studioSet: "/images/studio-set.jpg",
  studioAudience: "/images/studio-audience.jpg",
  studioOverShoulder: "/images/studio-overshoulder.jpg",
  drewSet: "/images/drive-4148.jpg",
  drew: "/images/drive-4148.jpg",
  valerie: "/images/with-valerie-bertinelli.jpg",
  portrait: "/images/meet-susan.png",
  seated: "/images/press-hat-seated.jpg",
  speaking: "/images/IMG_1119.jpg",
  greeting: "/images/IMG_1127.jpg",
  studio: "/images/IMG_2442.jpg",
  stage: "/images/IMG_1125.jpg",
  goop: "/images/press-goop-stage.jpg",
  whiteJacket: "/images/press-white-jacket.jpg",
  signing: "/images/press-signing-reader.jpg",
  blazerPortrait: "/images/redcarpet-candidate.jpg",
  bookCover: "/images/book-cover-real.jpg",
  theatre: "https://images.unsplash.com/photo-1562329265-95a6d7a83440?crop=entropy&cs=srgb&fm=jpg&q=85",
  candlelight: "https://images.unsplash.com/photo-1601922046210-41e129a3e64a?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const priceForZone = (zoneId) => {
  const map = {
    vipexp: 1000,
    selectp: 149,
    select: 129,
    general: 90,
  };
  return map[zoneId] ?? 0;
};
